let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aJtgP")).then(() => parcelRequire('eXzTm'));